module.exports = __webpack_public_path__ + "img/lane-changing.96c5a78d.svg";